import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import ViewpointFields from './formGroup12ViewpointFields';
import CamerasFields from './formGroup21CamerasFields';

export default {
  title: 'Offset map',
  attributeName: 'cameras',
  validationUrl:'live',
  fields: [
    // {
    //   attributeName: 'cameras',
    //   type: FormInputTypes.JSON_COMPONENT,
    //   canCreate: false,
    //   canRemove:false,
    //   canEdit:false,
    //   emptyMessage: "You don't have any view point yet.",
    //   columns:1,
    //   label: 'Cameras',
    //   itemLabel:'Cameras',
    //   required: true,
    //   helpText: 'Insert new view points clicking in + button.',
    //   errorText: '',
    //   popupFormGroups:[
    //     CamerasFields
        

    //   ]
    // },
    {
      attributeName: 'positionOffsetX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset X',
      required: true,
      className:'col-sm-4',
      default:"0.0",
      helpText: 'Set the offset pos x.',
      errorText: '',
    },
    {
      attributeName: 'positionOffsetY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset Y',
      required: true,
      className:'col-sm-4',
      default:"0.0",
      helpText: 'Set the offset pos y.',
      errorText: '',
    },
    {
      attributeName: 'positionOffsetZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position offset Z',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the offset pos z.',
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset X',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot x.',
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset Y',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot Y.',
      errorText: '',
    },
    {
      attributeName: 'rotationOffsetZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation offset Z',
      required: true,
      className:'col-sm-4',
      default:"0",
      helpText: 'Set the panel rot z.',
      errorText: '',
    },
    {
      attributeName: 'scale',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Scale',
      required: true,
      className:'col-sm-4',
      default:"1",
      helpText: 'Set the scale.',
      errorText: '',
    },
    // {
    //   attributeName: 'cameras',
    //   type: FormInputTypes.CAMERAS_PRESENTATION,
    //   emptyMessage: "You don't have any view point yet.",
    //   label: 'Cameras',
    //   itemLabel:'Cameras',
    //   required: true,
    //   helpText: 'Insert new view points clicking in + button.',
    //   errorText: '',
    // },
  ]
};